/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { forwardRef } from "react";
import { colors } from "./colors";
import { IconWrapperRounded } from "./IconWrapperRounded";
import { StyledText } from "../assets/typography/typography";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  selected: boolean;
  children: React.ReactNode;
  icon: React.ReactNode;
}

export const SelectableItem = forwardRef(
  ({ selected, children, icon, ...rest }: Props, ref) => {
    const wrapperStyle = css`
      width: 100%;
      background-color: ${selected ? colors.whiteHover : colors.transparent};
      padding: 4px 12px;
      border-radius: 6px;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      color: ${colors.textPrimary};
      &:hover {
        background-color: ${colors.whiteHover};
      }
    `;
    return (
      <div ref={ref as React.Ref<HTMLDivElement>} css={wrapperStyle} {...rest}>
        <IconWrapperRounded backgroundColor={colors.transparent}>
          {icon}
        </IconWrapperRounded>
        <StyledText className="bodyTextRegular mb-0">{children}</StyledText>
      </div>
    );
  }
);
